import { commonScopes, type Translate } from '../../explanations/common';
import type { Explanation } from '../../explanations/types';

export const vendasKpiExplanations = (t: Translate): { taxaRecorrencia: Explanation } => ({
  taxaRecorrencia: {
    what: t('Quantos dos clientes com OS no período já tinham comprado antes.'),
    calculation: [
      t('Clientes com outra OS anterior a uma OS do período'),
      t('÷ clientes com OS no período'),
    ],
    scope: `${commonScopes(t).franchiseFilterAndPeriod} ${t('OS canceladas não contam.')}`,
  },
});
